var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBigArrowRight56 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 56,
  height: 56,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M18.146 7.146a.5.5 0 0 1 .708 0l20 20a.5.5 0 0 1 0 .708l-20 20a.5.5 0 0 1-.708-.708L37.793 27.5 18.146 7.854a.5.5 0 0 1 0-.708Z",
  clipRule: "evenodd"
})));
export { SvgBigArrowRight56 as ReactComponent };
export default __webpack_public_path__ + "a531a043e11d81e2a3fb16c50d2d2341.svg";